import { React, useState, useEffect, useRef, useContext } from "react";
import Button from "@mui/material/Button";
import axios from "axios";
import { AppContext } from '../../../AppStore';
import GridNoRow from '../../../common/GridNoRow';
import { DataGrid } from '@mui/x-data-grid';
import PCSelectModal from "../PCSelectModal";

function ResourceSelectModal({ title, onClose, handleResourceClick }) {
  const appStore = useContext(AppContext);
  const searchRef = useRef(null);
  const [keyword, setKeyword] = useState('');
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    id: false,
    resource_name: true,
    resource_number: true,
    resource_type: false,
    resource_type_name: true,
    resource_status: false,
    resource_status_name: true,
    resource_workplace_id: false,
    resource_workplace_name: true,
    resource_location: false
  });

  useEffect(() => {
    // Mount 될때만 실행된다.
    handleSetting();
    searchRef.current.focus();
    handleView();

    setColumnVisibilityModel({
      id: false,
      resource_name: true,
      resource_number: true,
      resource_type: false,
      resource_type_name: true,
      resource_status: false,
      resource_status_name: true,
      resource_workplace_id: false,
      resource_workplace_name: true,
      resource_location: false
    });
  }, []);


  useEffect(() => {
    //렌더링 될 때 마다 실행된다.
  });

  const onSubmitSearch = (e) => {
    //입력 검색어는 Enter로 조회.
    if (e.key === "Enter") {
      handleView();
    }
  };
  
  const handleSetting = () => {
    setColumns([
        { field: 'id', headerName: 'resource_id', width: 0, headerAlign: 'center' },
        { field: 'resource_name', headerName: '자원명', width: 150, headerAlign: 'center' },
        { field: 'resource_number', headerName: '자원번호', width: 120, headerAlign: 'center', align:'center' },
        { field: 'resource_type', headerName: 'resource_type', width: 0, headerAlign: 'center', align:'center' },
        { field: 'resource_type_name', headerName: '자원유형', width: 90, headerAlign: 'center', align:'center' },
        { field: 'resource_status', headerName: 'resource_status', width: 0, headerAlign: 'center', align:'center' },
        { field: 'resource_status_name', headerName: '자원상태', width: 80, headerAlign: 'center', align:'center' },
        { field: 'resource_workplace_id', headerName: 'resource_workplace_id', width: 0, headerAlign: 'center', align:'center' },
        { field: 'resource_workplace_name', headerName: '자원사업장', width: 120, headerAlign: 'center', align:'left' },
        { field: 'resource_location', headerName: '자원위치', width: 0, headerAlign: 'center', align:'left' }
    ]);
  }

  const handleView = () => {
    axios.get('/api/SelectCommon/ResourceList',
        {
        params : {
          keyword: keyword
        }
      },
      { withCredentials: true }
    )
    .then((response) => {
      var array = response.data.map((item, index) => ({
          id: item.resource_id,
          resource_name: item.resource_name,
          resource_number: item.resource_number,
          resource_type: item.resource_type,
          resource_type_name: item.resource_type_name,
          resource_status: item.resource_status,
          resource_status_name: item.resource_status_name,
          resource_workplace_id: item.resource_workplace_id,
          resource_workplace_name: item.resource_workplace_name,
          resource_location: item.resource_location
      }));
      setRows(array);
      
    })
    .catch((error) => {
        appStore.capture();
    });
  };

  const handleRowClick = (params) => {
    //부모로 연결된 클릭 이벤트 부모에 handleResourceClick 이벤트 만들어 놓아야함.
    handleResourceClick(params.row);
    onClose?.();
  };

  const handleDelete = () => {
    handleResourceClick({
      id: '',
      resource_name: '',
      resource_number: '',
      resource_type: '',
      resource_type_name: '',
      resource_status: '',
      resource_status_name: '',
      resource_workplace_id: '',
      resource_workplace_name: '',
      resource_location: ''
    });
    onClose?.();
  };

  return (
    <PCSelectModal onClose={onClose} title={title}>
        <div className="modal" style={{ maxHeight : '435px' }}>
          <table className="SelectModalTABLE">
            <tbody>
            <tr>
              <td className="SelectModalTD" colSpan={2} style={ { padding: '5px' } }>
                <div className="modal_filed_input" style={ { width: 'calc(100% - 190px)', float: 'left' } }>
                  <input type="text" placeholder="검색" value={keyword} name="keyword" onChange={(e) => setKeyword(e.target.value) } onKeyPress={onSubmitSearch} ref={searchRef} autoComplete="off" />
                </div>
                
                <div className="modal_filed_input" style={ { float: 'right' } }>
                  <Button 
                    onClick={handleView}
                    className="btn-p btn-m"
                    sx={{  
                        m: 1, 
                        fontSize: 12, 
                        color: "white", 
                        borderColor: "#3D63AE", 
                        backgroundColor: "#3D63AE",
                        margin: '0px',
                        ":hover": { boxShadow: "2px 2px 2px #3D63AE" , backgroundColor: "#3D63AE", borderColor: "#3D63AE"}
                    }} 
                    variant="outlined">
                    조회
                  </Button>
                </div>
                <div className="modal_filed_input" style={ { float: 'right', paddingRight: '8px' } }>
                  <Button 
                    onClick={handleDelete}
                    className="btn-p btn-m"
                    sx={{  
                        m: 1, 
                        fontSize: 12, 
                        color: "white", 
                        borderColor: "#FF3636", 
                        backgroundColor: "#FF3636",
                        margin: '0px',
                        ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                    }} 
                    variant="outlined">
                    삭제
                  </Button>
                </div>
              </td>
            </tr>
            <tr>
              <td className="SelectModalTD" colSpan={2}>
                <div style={{ padding: '5px', height: '300px' }}>
                  <DataGrid
                    rows={rows}
                    columns={columns}
                    columnVisibilityModel={columnVisibilityModel}
                    onProcessRowUpdateError={(error) => error}
                    AlternatingRowBackground="LavenderBlush"
                    rowsPerPageOptions={[20, 50, 100]}
                    onRowClick={handleRowClick}
                    initialState={{ 
                        density: 'compact'
                    }}
                    slots={{
                        noRowsOverlay: GridNoRow,
                    }}
                    sx={{
                      cursor: "pointer"
                    }}      
                    disableColumnSorting 
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td className="SelectModalTD" colSpan={2}>
                <div className="select_modal_action">
                  <div className="select_modal_button">
                    <Button 
                      onClick={()=> { onClose?.(); }}
                      className="btn-p btn-m"
                      sx={{  
                          m: 1, 
                          fontSize: 12, 
                          color: "white", 
                          borderColor: "#808080", 
                          backgroundColor: "#808080",
                          ":hover": { boxShadow: "2px 2px 2px #808080" , backgroundColor: "#808080", borderColor: "#808080"}
                      }} 
                      variant="outlined">
                      닫기
                    </Button>
                  </div>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
    </PCSelectModal>
  );
}

export default ResourceSelectModal;